/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Tlm_1Inputs */

const en_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`browsers`)
};

const ar_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المتصفحات`)
};

const bn_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`browsers`)
};

const de_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser`)
};

const es_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navegadores`)
};

const fr_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navigateurs`)
};

const pt_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navegadores`)
};

const zh_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器`)
};

const tr_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tarayıcılar`)
};

const ru_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`браузеров`)
};

const pl_svc_browser_extensions_tlm_1 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`przeglądarki`)
};

/**
* | output |
* | --- |
* | "browsers" |
*
* @param {Svc_Browser_Extensions_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_tlm_1 = /** @type {((inputs?: Svc_Browser_Extensions_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_tlm_1(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_tlm_1(inputs)
	if (locale === "de") return de_svc_browser_extensions_tlm_1(inputs)
	if (locale === "es") return es_svc_browser_extensions_tlm_1(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_tlm_1(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_tlm_1(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_tlm_1(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_tlm_1(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_tlm_1(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_tlm_1(inputs)
	return en_svc_browser_extensions_tlm_1(inputs)
});
export { svc_browser_extensions_tlm_1 as "svc_browser-extensions_tlm_1" }